<template>
  <BottomSheet
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    title="Ethicc"
  >
    <div class="main-menu">
      <!-- Groupe Projets et Clients -->
      <div class="menu-items">
        <MenuItem
          v-for="item in menuGroups.projects"
          :key="item.path.name"
          :title="item.name"
          :route="item.path"
          :icon="item.icon"
          mobile
          @select="$emit('update:modelValue', false)"
        />
      </div>

      <hr v-if="menuGroups.settings.length > 0" class="menu-divider" />

      <!-- Groupe Paramètres -->
      <div class="menu-items">
        <MenuItem
          v-for="item in menuGroups.settings"
          :key="item.path.name"
          :title="item.name"
          :route="item.path"
          :icon="item.icon"
          mobile
          @select="$emit('update:modelValue', false)"
        />
      </div>

      <!-- Environnement et Version -->
<div class="env-info">
  <span class="env-name">{{ environment === 'development' ? 'Local' : 'Ethicc' }}</span>
  <span class="version">v{{ version }}</span>
</div>
    </div>
  </BottomSheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BottomSheet from '@/components/BottomSheet.vue'
import MenuItem from '@/components/menu/MenuItem.vue'
import { version } from '../../../package.json'
const environment = import.meta.env.VITE_APP_ENV || 'development'

const props = defineProps<{
  modelValue: boolean
  userRole?: number | null
}>()

defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const menuGroups = computed(() => ({
  projects: [
    { name: 'Projets', path: { name: 'Projets' }, icon: 'home' },
    { name: 'Clients', path: { name: 'Clients' }, icon: 'users' }
  ],
  settings: props.userRole === 1 ? [
    { name: 'Administration', path: { name: 'Administration' }, icon: 'settings' }
  ] : []
}))
</script>

<style scoped>
.main-menu {
  display: flex;
  flex-direction: column;
  padding: 0 16px 32px;
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu-divider {
  margin: 8px 0;
  border: none;
  border-top: 1px solid var(--layout-border);
}

.env-info {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
  padding: 8px 12px;
  border-radius: 8px;
  color: var(--text-placeholder);
  font-size: 13px;
  justify-content: center;
}

.env-name {
  font-weight: 500;
}

</style>
